<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Voyage Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.voy }}</td>
          <td class="text-xs-left">{{ props.item.voyDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Voyage<v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="voyDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newVoyage">
                  <v-text-field v-model="voyForm.voy" :label="labels.voy" :error-messages="errors.collect('voy')" data-vv-name="voy" :data-vv-as="labels.voy" v-validate="'required|param|max:10'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.voy}}</v-subheader>
                  <div class="subheading">{{voyForm.voy}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="voyForm.voyDesc" :label="labels.voyDesc" :error-messages="errors.collect('voyDesc')" v-validate="'required|entry|max:100'" data-vv-name="voyDesc" :data-vv-as="labels.voyDesc"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Cargo Port? ({{deleteCrgoVoy}})
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Voyage', value: 'voy' },
        { text: 'Voyage Description', value: 'voyDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Voyage Details',
        voy: 'Voyage*',
        voyDesc: 'Voyage Description*'
      },
      voyForm: {
        voy: null,
        voyDesc: null
      },
      filters: {
        voy: null,
        voyDesc: null
      },
      voyDialog: null,
      newVoyage: null,
      sumbitting: undefined,
      promptRemove: false,
      selectedCrgoVoy: undefined,
      deleteCrgoVoy: ''
    }
  },
  computed: {
    voy() {
      return this.$store.state.cargo.menu
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiURI = this.voy.getCrgoVoyages
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((voy) => {
              const convertVoyage = {
                voy: voy.voy,
                voyDesc: voy.voyDesc
              }
              this.items.push(convertVoyage)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      this.init()
    },
    async doReview(data) {
      this.voyDialog = true
      this.newVoyage = false
      const apiURI = this.voy.getCrgoVoyage
      const expand = {
        voy: data.item.voy
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.voyForm.voy = data.voy.voy
          this.voyForm.voyDesc = data.voy.voyDesc
        }
        this.voyDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newVoyage = true
      this.voyDialog = true
    },
    doClose() {
      this.newVoyage = false
      this.voyDialog = false
      this.voyForm.voy = null
      this.voyForm.voyDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newVoyage) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.voy.createVoyage
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.voyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.voy.updateVoyage
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.voyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrgoVoy = data
        this.deleteCrgoVoy = data.voy + ' - ' + data.voyDesc
      }
    },
    async doRemove() {
      const apiURI = this.voy.deleteVoyage
      if (apiURI) {
        this.loading = true
        const expand = {
          voy: this.selectedCrgoVoy.voy
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
